var chunkMapping = {
	"674": [
		3674
	]
};
var idToExternalAndNameMapping = {
	"3674": [
		"default",
		"./PrettyLoad",
		7251
	]
};
var idToRemoteMap = {
	"3674": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 7251
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}